<template>
    <div class="list-card">
        <div class="container-card" v-for="post in posts" :key="post.id">
            <div class="picture">
                <i v-if="post.type && post.type == 'NATIVE_DOCUMENT'"  class="fa-regular fa-file-pdf"></i>
                <img v-else-if="post.attachment_url" :src="post.attachment_url">
                <i v-else class="fa-regular fa-image-slash"></i>
            </div>
           
            <div class="content-card">
                <div class="container-date">
                <p class="date">{{ getFormatDate(post.created_time) }}</p>
                </div>
                <h4 class="title">{{post.message}}</h4>
                <div class="table">
                <table>
                    <tr v-if="post.post_impressions">
                        <td>Impressions</td>
                        <td class="value">{{ post.post_impressions }}</td>
                    </tr>
                    <tr v-if="post.interactions">
                        <td>Interactions</td>
                        <td class="value">{{ post.interactions }}</td>
                    </tr>
                    <tr v-if="post.post_reactions_sum">
                        <td>Réactions</td>
                        <td class="value">{{ post.post_reactions_sum }}</td>
                    </tr>

                    <tr>
                        <td>Commentaires</td>
                        <td class="value">{{ post.comments_count ? post.comments_count : 0 }}</td>
                    </tr>

                    <tr>
                        <td>Partages</td>
                        <td class="value">{{ post.shares_count ? post.post_reactions_sum : 0 }}</td>
                    </tr>

                    
                    <tr v-if="post.link_clicks">
                        <td>Clics</td>
                        <td class="value">{{ post.link_clicks }}</td>
                    </tr>
                 
                </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            posts: {
                type: Array,
                default: function() {
                    return []
                }
            },
        },

        methods: {
            getFormatDate(dateString) {
                return (new Date(dateString)).toLocaleString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' })
            }
        },
    }
</script>